import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Accordion, Card } from 'react-bootstrap';

// Layout
import Header1 from '../layout/header/header2';
import Footer1 from '../layout/footer/footer1';

// Elements
import SolutionSidebar from '../elements/services/solution-sidebar';

// Images
import Banner1 from '../../images/banner/banner1.jpg';
import ServicesPic1 from '../../images/services/service_11.jpg';
import ServicesPic2 from '../../images/services/service_3.jpg';

class SolutionGeologicalReservoirAnalysis extends Component {

    render(){
        return (
            <>
                <Header1 />
                
                <div className="page-content bg-white">

                    <div className="page-banner ovbl-dark parallax" style={{backgroundImage: "url("+Banner1+")"}}>
                        <div className="container" style={{marginTop:56}}>
                            <div className="page-banner-entry">
                                <h1 className="text-white">Geological & Reservoir Analysis</h1>
                                <div className="breadcrumb-row">
                                    <ul className="list-inline">
                                        <li><Link to="/"><i className="fa fa-home"></i> Home</Link></li>
                                        <li>Geological & Reservoir Analysis</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content-block" id="content-area">

                        <div className="section-area section-sp2 bg-fix bg-white">
                            <div className="container about-video">
                                <div className="row">

                                    <div className="col-lg-4 col-md-5 m-b30">
                                        <SolutionSidebar activeService={1} />
                                    </div>

                                    <div className="col-lg-8 col-md-7 service-textarea">

                                        <div className="heading-bx text-left m-b20">
                                            <h3 className="title-head m-b0">Geological & Reservoir Analysis</h3>
                                            <div className="ttr-separator sepimg"></div>
                                        </div>

                                        <p>We deliver advanced geological and reservoir characterization solutions to help operators maximize field recovery through accurate modelling, pressure analysis and production forecasting.</p>

                                        <div className="row ">
                                            <div className="col-md-12 m-b15">
                                                <img src={ServicesPic1} className="radius-sm imghight" alt=""/>
                                            </div>
                                        </div>

                                        <h4 className="title m-b5">Our Solutions</h4>
                                        <p>Our expertise integrates geological modelling, petrophysical interpretation, reservoir simulation and diagnostic analysis to guide strategic decision-making.</p>

                                        <div className="row">
                                            <div className="col-lg-6">
                                                <ul className="list-check">
                                                    <li>Reservoir characterization</li>
                                                    <li>Pressure transient analysis</li>
                                                    <li>Production profiling</li>
                                                </ul>
                                            </div>
                                            <div className="col-lg-6">
                                                <ul className="list-check">
                                                    <li>Geological modelling</li>
                                                    <li>Enhanced recovery insights</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <h4 className="title m-b5">Key Benefits</h4>
                                        <p>Improve decision making, reduce uncertainty and optimize field recovery.</p>

                                        <div className="row">
                                            <div className="col-xl-5 col-lg-12">
                                                <img src={ServicesPic2} className="radius-sm m-b30" alt=""/>
                                            </div>
                                            <div className="col-xl-7 col-lg-12">
                                                <ul className="service-list-circle">
                                                    <li><i className="flaticon-maintenance"></i>Accurate subsurface understanding for reliable operational planning.</li>
                                                    <li><i className="flaticon-light-bolt"></i>Optimized reservoir performance prediction.</li>
                                                    <li><i className="flaticon-mask"></i>Improved recovery strategies and reduced uncertainty.</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <Accordion className="ttr-accordion gray" defaultActiveKey="0">
                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="0">
                                                    <Link to="#">Reservoir Modelling</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="0">
                                                    <Card.Body>
                                                        Construction of detailed 3D geological and reservoir models for accurate analysis.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="1">
                                                    <Link to="#">Pressure Analysis</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="1">
                                                    <Card.Body>
                                                        Pressure transient and productivity evaluation for well and reservoir diagnostics.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="2">
                                                    <Link to="#">Production Forecasting</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="2">
                                                    <Card.Body>
                                                        Short- and long-term production forecasting using advanced simulation tools.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        </Accordion>

                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <Footer1 />
            </>
        );
    }
}

export default SolutionGeologicalReservoirAnalysis;
